<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxFlexFill>
    <h1>{{typeErr || 'Nessun prodotto selezionato'}}</h1>
    <mat-icon color="warn">warning</mat-icon>
</div>